import React from 'react';
import Highcharts from 'highcharts';
import { Chart } from '../Chart';
import { useChartSettings } from '../hooks/useChartSettings';
import { axisSettings, AxisType, commonSettings } from '../charts.constants';
import { theme } from '../../../../theme/theme';

const chartSettings: Highcharts.Options = {
  ...commonSettings,

  chart: {
    type: 'areaspline',
    spacingTop: 20,
    spacingRight: 20,
    style: {
      fontFamily: theme.fontFamily,
    },
  },

  plotOptions: {
    areaspline: {
      lineWidth: 1,
      states: {
        hover: {
          lineWidth: 3,
        },
      },
      marker: {
        enabled: false,
      },
    },
  },
};

interface AreaSplineChartProps {
  series: {
    name: string;
    data: number[][];
  }[];
  customSettings?: Record<string, any>;
  xAxisType?: AxisType;
  yAxisType?: AxisType;
  containerProps?: Record<string, any>;
}

export const AreaSplineChart: React.FC<AreaSplineChartProps> = ({
  series,
  customSettings = {},
  xAxisType = 'decimal',
  yAxisType = 'decimal',
  containerProps,
}) => {
  const settings = useChartSettings({
    series,
    settings: chartSettings,
    customSettings: {
      ...customSettings,
      xAxis: {
        ...axisSettings[xAxisType],
        ...customSettings?.xAxis,
      },
      yAxis: {
        ...axisSettings[yAxisType],
        ...customSettings?.yAxis,
      },
    },
  });

  return <Chart options={settings} containerProps={containerProps} />;
};
